<template>
  <AdmPanel>
    <h2 slot="header_title">录入概况</h2>

    <FilterBar slot="header_buttons" :value="conditions" :condition="options.filter_rules" @search="changeQuery">
      <iv-form-item>
        <iv-button :disabled="loader[REPORT_DATA]" type="info" @click="changeQuery()"> <iv-icon type="md-search" size="14" style="vertical-align:text-bottom" />查询 </iv-button>
      </iv-form-item>
    </FilterBar>
    <div class="filter-wrapper">
      <!-- 筛选条件 -->
      <!-- <FilterBar
                v-model="conditions"
                :condition="options.filter_rules"
                @search="changeQuery">
                <iv-button
                    :disabled="loader[TARGET_DATA]"
                    type="primary"
                    @click="changeQuery()">
                    <iv-icon type="md-search" size="14" style="vertical-align:text-bottom" /> 查询
                </iv-button>
            </FilterBar> -->
    </div>
    <div v-loading="loader[TARGET_DATA]" style="position: relative">
      <p v-if="list.data.length <= 0" class="text-center">
        <EmptyData>
          <div class="nextPage" slot="emptyBtn">
            <iv-button @click="pageChanged">重新获取</iv-button>
          </div>
        </EmptyData>
      </p>
      <div class="adm-list" v-else>
        <GeneralizeItem :type="currentType" v-for="(item, index) in list.data" :key="index" :value="item" @showReportData="showReportData">
          <div><iv-button type="primary" @click="handleJumpToInput(item)">跳转录入</iv-button></div>
        </GeneralizeItem>
      </div>
    </div>
    <template v-if="list.last_page > 1">
      <div slot="footer" class="pull-right">
        <iv-page @on-change="pageChanged" :current="list.current_page" :page-size="10" show-elevator show-total :total="list.total"> </iv-page>
      </div>
    </template>
    <iv-modal v-model="status[REPORT_DATA].shown" :title="status[REPORT_DATA].title" :width="status[REPORT_DATA].width" closable>
      <iv-table border :columns="reportDataColumns" :data="options.thirdTargets" @on-sort-change="reportDataSort" />
      <div slot="footer"></div>
    </iv-modal>
    <ReportDataModal :title="editModel.title" :type="editModel.type" :value="editModel.reportData" :shown="editModel.shown" @shown-changed="editModel.shown = $event" />
  </AdmPanel>
</template>

<script>
import ModelMixin from '@/mixins/Model.mixin'
import StatusMixin from '@/mixins/Status.mixin'
import LoaderMixin from '@/mixins/Loader.mixin'
import contact from '@/utils/contact'
import { conditioner, defaultVal, carbon_years, BusinessError, RequestError, isNumber } from '@/utils/'

import ReportDataModal from '@/components/ReportDataModal'
import GeneralizeItem from '@/components/GeneralizeItem'
import FilterBar from '@/components/FilterBar_X2'
import EmptyData from '@/components/EmptyData'

import CarbonTargetDataModel from '@/models/CarbonTargetDataModel'
import ReportDataModel from '@/models/ReportDataModel'
import CarbonIndustryModel from '@/models/CarbonIndustryModel'
import CarbonCompanyModel from '@/models/CarbonCompanyModel'


const COMPANY = CarbonCompanyModel.ModelName
const REPORT_DATA = ReportDataModel.ModelName
const INDUSTRY = CarbonIndustryModel.ModelName
const TARGET_DATA = CarbonTargetDataModel.ModelName

const _years = carbon_years().map(year => ({ ...year, title: year.name }))

const options = {
  // year:[],
  industry: [],
  companys: [],
  thirdTargets: [],
  emptySecondTargets: [],
  targetType: [
    { id: '0', name: '定量' },
    { id: '1', name: '定性' }
  ],
  inputTab: [
    { id: '0', name: '全部' },
    { id: '1', name: '已完成' },
    { id: '2', name: '未完成' }
  ],
  reportTab: [
    { id: '0', name: '缺年报' },
    { id: '1', name: '缺社报' },
    { id: '2', name: '缺年/社报' }
  ],
  audit: [
    { id: '0', name: '' },
    { id: '1', name: '待审核' },
    { id: '2', name: '不通过' },
    { id: '3', name: '通过' }
  ]
}
export const _conditioner = conditioner(
  {
    limit: { type: Number, default: 10 },
    year: { type: Number, default: null },
    industryId: { type: Number, default: null },
    stockCode: { type: String, default: '' },
    inputStatus: { type: Number, default: 0 },
    reportStatus: { type: Number, default: '' },
    timestamp: { type: val => new Date().getTime(), default: () => new Date().getTime() }
  },
  {
    limit: { type: Number, default: 10 },
    year: { type: val => parseInt(val), default: () => _years[0].id },
    industryId: { type: Number, default: null },
    stockCode: { type: String, default: '' },
    inputStatus: { type: String, default: '0' },
    reportStatus: { type: String, default: '' }
  }
)
const filter_rules = [
  { name: 'year', type: 'Select', options: _years, title: '年份', default: '', placeholder: '年份' },
  { name: 'industryId', type: 'Select', options: [], title: '行业', default: '', placeholder: '行业', style: { width: '150px' } },
  { name: 'stockCode', type: 'Select', options: [], title: '公司', default: '', placeholder: '公司', filterable: true, clearable: true, style: { width: '150px' } },
  { name: 'inputStatus', type: 'Select', options: options.inputTab, title: '录入情况', default: '0', placeholder: '录入情况', style: { width: '120px' } },
  { name: 'reportStatus', type: 'Select', options: options.reportTab, title: '报告情况', default: '', placeholder: '报告情况', clearable: true, style: { width: '120px' } }
]

function columns (vm) {
  const allowControl = vm.$rbac.allow(['carbonTargetData', 'edit'], 'hidden')
  const columns = [
    {
      title: '年份',
      key: 'year',
      align: 'center',
      width: 70
    },
    {
      title: '企业名称',
      key: 'abbreviation',
      align: 'center',
      minWidth: 100
    },
    {
      title: '一级指标',
      key: 'firstTargetName',
      align: 'center',
      minWidth: 120
    },
    {
      title: '二级指标',
      key: 'secondTargetName',
      align: 'center',
      minWidth: 120
    },
    {
      title: '三级指标',
      key: 'thirdTargetName',
      align: 'center',
      minWidth: 120
    },
    {
      title: '指标单位',
      key: 'targetUnit',
      align: 'center',
      width: 70,
      render (h, params) {
        const item = params.row
        return <span>{!item.targetUnit ? '--' : item.targetUnit}</span>
      }
    },
    {
      title: '存档数据',
      key: 'value',
      align: 'center',
      minWidth: 100,
      sortable: 'custom'
    },
    {
      title: '得分',
      key: 'score',
      align: 'center',
      width: 90,
      sortable: 'custom'
    },
    {
      title: '补充说明',
      key: 'moreRemark',
      align: 'center',
      width: 90,
    },
    {
      title: '审核状态',
      key: 'score',
      align: 'center',
      width: 90,
      render (h, params) {
        const item = params.row
        if (typeof item.audit == 'string') return <span>{item.audit}</span>
        const audit = options.audit.find(tag => tag.id == item.audit)
        return <span>{audit.name}</span>
      }
    }
  ]
  if (allowControl)
    columns.push({
      title: '操作',
      align: 'center',
      width: 80,
      render (h, params) {
        const item = params.row
        return (
          <a href='javascript:;' class='' onClick={() => vm.edit(item)}>
            编辑
          </a>
        )
      }
    })
  return columns
}

export default {
  name: 'targetData_index',
  components: {
    FilterBar,
    EmptyData,
    ReportDataModal,
    GeneralizeItem
  },
  mixins: [
    LoaderMixin(INDUSTRY, TARGET_DATA),
    StatusMixin(REPORT_DATA)([
      { name: 'title', default: '' },
      { name: 'shown', default: false },
      { name: 'width', default: '900px' },
      { name: 'done', default: false }
    ]),
    ModelMixin({
      contact,
      models: [CarbonCompanyModel, CarbonIndustryModel, CarbonTargetDataModel, ReportDataModel]
    })
  ],
  data () {
    return {
      REPORT_DATA,
      INDUSTRY,
      TARGET_DATA,
      conditions: _conditioner.default(),
      reportDataColumns: columns(this),
      list: {
        data: [],
        last_page: 0,
        current_page: 1
      },
      options: {
        ...options,
        filter_rules,
        industry: [],
        companys: []
      },
      source: {},
      editModel: {
        shown: false,
        reportData: null,
        type: '',
        title: ''
      },
      currentType:"carbon",
      currentItem:{}
    }
  },
  async mounted () {
    const { query, params } = this.$route
    let conditions = _conditioner.serialize({ ...query, ...params }) //处理成支持UI的格式
    const industries = await this.refreshIndustry(conditions.year)
    conditions.industryId = conditions.industryId ? conditions.industryId : industries[0].id
    const companys = await this.refreshCompanys(conditions.industryId)
    this.renderFilterBar('industryId', industries)
    this.renderFilterBar('stockCode', companys)

    this.conditions = conditions
    this.$nextTick(() => {
      this.refresh(conditions)
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.$nextTick(async () => {
      const { query, params } = to
      let conditions = {
        ..._conditioner.default(),
        ..._conditioner.serialize({ ...query, ...params }) //处理成支持UI的格式
      }
      conditions.industryId = defaultVal(conditions.industryId, this.options.industry[0].id)
      this.conditions = conditions
      // await this.refreshCompanys(conditions.industryId)
      this.refresh()
    })
    next()
  },
  methods: {
    async refresh (query = this.conditions) {
      this.list = await this.$$active(TARGET_DATA, 'inputStatus', _conditioner.parse(query))
      this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
      this.list.last_page = this.list.total / _conditioner.parse(query).limit
    },
    async refreshCompanys (industryId) {
      const company = await this.$$fetch(COMPANY, { industryId: industryId })
      return (this.options.companys = company.data.map(item => ({ id: item.stockCode, name: item.stockCode + ' ' + item.abbreviation })))
    },
    async refreshIndustry (year) {
      const industry = await this.$$fetch(INDUSTRY, {year: year})
      if (industry) this.options.industry = industry.data.map(item => ({ ...item, name: item.industry }))
      return this.options.industry
    },
    renderFilterBar (fieldName, val, defaults) {
      const fieldset = this.options.filter_rules.find(fieldset => fieldset.name === fieldName)
      fieldset.options = val
    },
    pageChanged (page) {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: (page - 1) * _conditioner.parse(this.conditions).limit }, params: this.$route.params })
    },
    mergeQuery (query) {
      return { ...this.conditions, ...query }
    },
    changeQuery (query = this.conditions, params = this.$route.params) {
      this.$router.push({
        name: this.$route.name,
        query: { ..._conditioner.parse(query), offset: 0 },
        params: params
      })
    },
    handleJumpToInput (item) {
      let routerJump = this.$router.resolve({
        path: '/carbon/targetData/input',
        query: {
          industryId: item.industryId,
          year: item.year,
          stockCode: item.stockCode
        }
      })
      window.open(routerJump.href, '_blank')
    },
    // 点击查看
    showReportData (params) {
      const { value,type } = params
      this.currentItem = value
      this.refreshReportData(type, value)
      this.status[REPORT_DATA].title = `${value.abbreviation} 全部指标数据`
      this.status[REPORT_DATA].shown = true
    },
    async refreshReportData (type, item) {
      const report_data_res = await this.$$fetch(REPORT_DATA, {
        type,
        year: item.year,
        stockCode: item.stockCode,
        industryId: item.industryId,
        abbreviation: item.abbreviation,
        ordering: item.ordering ? item.ordering : ""
      })
      if ([BusinessError, RequestError, Error].indexOf(report_data_res.constructor) == -1) {
        const { data: report_data_list = [] } = report_data_res
        if (report_data_list.length == 0) {
          return
        } else {
          this.options.thirdTargets = report_data_list.map(i => {
            return ReportDataModel.schema.format(i)
          })
        }
      }
    },
    // 编辑函数
    edit (item) {
      this.editModel.type = this.currentType
      this.editModel.shown = true
      this.editModel.reportData = { ...item, industryId: this.conditions.industryId }
      this.editModel.title = `正在编辑 ${item.abbreviation} - ${item.thirdTargetName} 指标数据`
    },

    //排序
    reportDataSort(val){
        console.log(val,"order")
        const ordering = ["",`-${val.key}`,val.key][["normal","asc","desc"].indexOf(val.order)]
        this.refreshReportData(this.currentType, { ...this.currentItem, ordering: ordering })
    }
  },
  watch: {
    'conditions.year': {
      async handler (newVal, oldVal) {
        if (oldVal) {
          let industries = await this.refreshIndustry(newVal)
          this.renderFilterBar('industryId', industries)
        }
      }
    },
    'conditions.industryId': {
      async handler (newVal, oldVal) {
        if (oldVal) {
          let companys = await this.refreshCompanys(newVal)
          this.renderFilterBar('stockCode', companys)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0px 10px;
  border-bottom: solid 1px #ddd;
  .upload-report-btn {
    position: absolute;
    right: 10px;
    bottom: 20px;
  }
  form {
    display: inline-block;
    margin-right: 30px;
  }
  span {
    margin-bottom: 20px;
  }
}
.adm-panel__tools {
  margin-bottom: -50px;
}
.adm-list {
  > * {
    border-bottom: solid 1px #ddd;
    list-style: none;
  }
  // .adm-content-item {
  //   width: 100%;
  //   height: 101px;
  //   border-bottom: solid 1px #ddd;
  //   box-sizing: border-box;
  //   display: flex;
  //   .adm-content-item-desc {
  //     padding: 10px 20px;
  //     flex: 1;
  //     .item-report-title {
  //       margin-bottom: 15px;
  //       color: #000;
  //     }
  //     .item-report-desc {
  //       margin-bottom: 5px;
  //       span {
  //         margin-right: 20px;
  //         display: inline-block;
  //         width: 150px;
  //       }
  //     }
  //   }
  //   .adm-content-item-operation {
  //     width: 140px;
  //     height: 101px;
  //     line-height: 101px;
  //     button {
  //       margin-right: 10px;
  //     }
  //   }
  // }
}
.upload-file-name {
  margin-left: 10px;
  width: 290px;
  line-height: 12px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-file-remove-btn {
  line-height: 12px;
}

.nextPage {
  margin: 15px 0;
  display: flex;
  justify-content: center;
  text-align: center;
  button {
    width: 200px;
  }
}
</style>
